module.exports = __webpack_public_path__ + "static/gym-0aee4a3e7474588f1803f5660d8b2838.jpg";